import React from 'react';
import moment from 'moment';
import { Wrapper, Left, Right } from './InfoGroup.Styles';
import { Typography, Input, DatePicker } from 'antd';

import StatusChangeDropdown from '../StatusChangeDropdown/StatusChangeDropdown';
import RoleChangeDropdown from '../RoleChangeDropdown/RoleChangeDropdown';
import formatToCurrency from '../../Utils/formatToCurrency';
const { Text } = Typography;

const InfoGroup = ({
  editable,
  text,
  placeHolder,
  type,
  editing,
  data,
  onNameChange,
  id,
  onChange,
}) => {
  return (
    <Wrapper>
      <Left>
        <Text>{text}</Text>
      </Left>
      {editable && editing && (
        <Right>
          {type === 'text' && (
            <Input
              size="small"
              placeholder={placeHolder}
              value={data}
              onChange={(e) => onChange(e.target.value, id)}
            />
          )}
          {type === 'date' && (
            <DatePicker
              allowClear={false}
              size="small"
              value={data ? moment(data, 'YYYY-MM-DD') : null}
              onChange={(dateString) =>
                onChange(dateString.toISOString(true).slice(0, 10), id)
              }
            />
          )}
          {type === 'number' && (
            <Input
              size="small"
              placeholder={placeHolder}
              value={data}
              onChange={(e) => onChange(e.target.value, id)}
            />
          )}
          {type === 'currency' && (
            <Input
              size="small"
              placeholder={placeHolder}
              value={data}
              onChange={(e) => onChange(e.target.value, id)}
            />
          )}
          {type === 'status-drop-down' && (
            <StatusChangeDropdown
              value={data}
              onChange={(e) => onChange(e, id)}
            />
          )}
          {type === 'role-drop-down' && (
            <RoleChangeDropdown
              value={data}
              onChange={(e) => onChange(e, id)}
            />
          )}
        </Right>
      )}
      {!editing && type === 'currency' && <Text>{formatToCurrency(data)}</Text>}
      {!editing && type !== 'currency' && <Text>{data}</Text>}
    </Wrapper>
  );
};

export default InfoGroup;
